import React from "react"
import { useNavigate } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { Button, Form, Input, Select } from "antd"

// Constants
import { TEMPLATE } from "../../../../../../constants"

// Components
import showSecondarySidebar from "../../../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../../../components/Decoration/Page"

// Services Library
import { REDUX } from "../../../../../../services/util"

// Redux Actions
import * as REDUX_ACTIONS from '../../../../../../services/redux/actions'

// Style
import styles from '../../../../../VehicleManagement/modules/index.module.css'

const { NOTIFICATION_CODE } = TEMPLATE.NOTIFICATIONS

const RuleTemplateCUForm = ({
    data = {}
}) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [ form ] = Form.useForm()

    const title = data?.title || 'Create'

    const uid = useSelector(REDUX.reduxStoreWrapper('user.uid'))
    const users = useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID'))

    const recipientOptions = Object.values(users)?.map(u => ({
        label: u.name,
        value: u.uid
    }))

    const onFinish = e => {

        const items = {
            ...e,
            default: 0,
            recipients: [{ uid: e.recipients }],
            status: data.status || 1,
            ruletid: data.ruletid,
            uid,
        }

        switch(title) {
            case 'Create': {
                dispatch(REDUX_ACTIONS.v3_ruleTemplates.create_rule_template_request(items, () => {
                    navigate(`/management/rule`)
                }))
                break;
            }
            case 'Edit': {
                dispatch(REDUX_ACTIONS.v3_ruleTemplates.update_rule_template_request(items, () => {
                    navigate(`/management/rule`)
                }))
                break;
            }
        }
    }

    const NotificationTypeOptions = Object.keys(NOTIFICATION_CODE).map(code => ({
        value: Number(code),
        label: NOTIFICATION_CODE[code]
    }))

    return (
        <div className="page-container">
            <Page title={`${title} Rule Template`}>
                <Form 
                    style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
                    labelCol={{ span: 5 }}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        ...data,
                        notificationType: 602,
                        recipients: data?.recipients?.[0]?.uid
                    }}
                >
                    <Form.Item
                        label="Rule Template Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: 'Please input rule template name!',
                            },
                        ]}
                    >
                        <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        label="Notification Type"
                        name="notificationType"
                        rules={[
                            {
                                required: true,
                                message: 'Please input notification type!',
                            },
                        ]}
                    >
                        <Select size="large" options={NotificationTypeOptions} />
                    </Form.Item>
                    <Form.Item
                        label="Recipient 1"
                        name="recipients"
                        rules={[
                            {
                                required: true,
                                message: 'Please input recipient!',
                            },
                        ]}
                    >
                        <Select size="large" options={recipientOptions} />
                    </Form.Item>

                        <div className={styles['button-container']}>
                            <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(-1)}>Cancel</Button>
                            <Button className={`${styles['button']} ${styles['add']}`} htmlType="submit">{title === 'Create' ? 'Add' : 'Save'}</Button>
                        </div>
                </Form>
            </Page>
        </div>
    )
}

const MemoizedRuleTemplateCUForm = React.memo(RuleTemplateCUForm);

export default showSecondarySidebar(false)(MemoizedRuleTemplateCUForm);